import React, { useEffect } from "react";
import { useRouter } from "next/router";

import {
  Button,
  ErrorUI,
  Image,
  MobileContainer,
  SVGSprite,
} from "@/components/Atoms";
import ModalMotion, { AnimateDirection } from "@/components/Molecules/Modal";

import { useAppSelector } from "@/hooks";

import styles from "./SessionDetailModal.module.scss";

const SessionDetailModal = ({
  openDetailModal,
  setOpenDetailModal,
  isSingleClassPurchasePage,
  setOpenPaymentModal,
  setOpenWaitListModal,
  isRenewalPage,
}) => {
  const router = useRouter();

  const {
    time,
    date,
    title,
    description,
    location,
    thumbnail,
    centerName,
    backupImageUrl,
    googleMapLink,
    shyftPassLogo,
    isEventEnded,
    eventEndedMessage,
    allSlotsBookedMessage,
    classDetail,
    isWaitListEnabled,
    isWaitListJoined,
  } = openDetailModal;

  const { packages, waitListSuccess } = useAppSelector(
    (state) => state.shyftPass
  );

  const arrowRight = (
    <SVGSprite
      className="icon"
      icon="icon-arrow-right-book-slot"
      height="24px"
      width="24px"
      style={{ marginLeft: "4px" }}
    />
  );

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  const arrowIcon = (
    <SVGSprite
      className="icon"
      icon="icon-arrow-right-book-slot"
      height="24px"
      width="24px"
    />
  );

  const successIcon = (
    <SVGSprite
      className="icon"
      icon="icon-arrow-right-success"
      height="24px"
      width="24px"
      fill="#fff"
    />
  );

  let button;
  if (isEventEnded) {
    button = (
      <Button variant={"primary1"} className="all-slots-booked" disabled>
        {eventEndedMessage || "Can't book now. This event has ended!"}
      </Button>
    );
  } else if (classDetail?.hasAllSlotsBooked) {
    if (isWaitListEnabled) {
      button = (
        <div className="wait-list-wrapper">
          <ErrorUI
            error={allSlotsBookedMessage || "All slots are booked!"}
            isNotAbsolute
            iconDimension="18px"
            fontSize="14px"
            lineHeight="24px"
          />
          {isWaitListJoined || waitListSuccess ? (
            <Button
              className={styles.single}
              variant={"primary1"}
              TextColor="#32D583"
            >
              Added to waitlist
              {successIcon}
            </Button>
          ) : (
            <Button
              className={styles.single}
              variant={"primary1"}
              onClick={() => setOpenWaitListModal(openDetailModal)}
            >
              Join the waitlist
              {arrowIcon}
            </Button>
          )}
        </div>
      );
    } else {
      button = (
        <Button variant={"primary1"} className="all-slots-booked" disabled>
          All slots are booked
        </Button>
      );
    }
  } else {
    button = (
      <Button
        variant="primary1"
        className={styles.single}
        onClick={() => setOpenPaymentModal(openDetailModal)}
      >
        Book your slot for ₹ {openDetailModal.price || packages?.[0]?.price}
        {arrowRight}
      </Button>
    );
  }

  return (
    <ModalMotion
      className={styles.detailModal}
      overlayClosable={true}
      onClose={() => setOpenDetailModal(false)}
      width="60%"
      animateDirection={AnimateDirection.BOTTOM}
      borderRadius="10px"
      showClose
      iconTopPosition="20px"
      iconRightPosition="20px"
      // btnPos={btnPos}
      bodyPadding={"40px"}
    >
      <div className={styles.sessionDetailContainer}>
        <div className={styles.sessionDetailCard}>
          <div className={styles.thumbnail}>
            <Image
              src={thumbnail || backupImageUrl}
              alt={title || "workout-session"}
            />
            {shyftPassLogo && (
              <div className={styles.shyftLogo}>
                <Image
                  src={
                    shyftPassLogo ||
                    "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2023-06/Logoshyft_pass_logo_1-cdf5f66dbccb451fb47634a8ce9f22cf.png"
                  }
                  alt="shyft pass logo"
                />
              </div>
            )}
          </div>
          <div className={styles.sessionData}>
            <div className={styles.title}>{title}</div>
            <div className={styles.description}>{description}</div>
            <hr className={styles.separator} />
            <div className={styles.locationContainer}>
              <div className={styles.location}>
                <div className={styles.icon}>
                  <SVGSprite
                    icon="icon-location-pin"
                    height="20px"
                    width="10px"
                  />
                </div>
                <div className={styles.locationText}>
                  {centerName} - {location}
                </div>
              </div>
              <a
                href={googleMapLink}
                target="_blank"
                rel="noreferrer"
                className={styles.maps}
              >
                <span>Maps</span>
                <SVGSprite
                  icon="icon-arrow-right-maps"
                  height="14px"
                  width="11px"
                />
              </a>
            </div>
            {(isSingleClassPurchasePage || isRenewalPage) && (
              <MobileContainer>
                <div className={styles.purchaseButton}>
                  {button}
                  {isSingleClassPurchasePage && (
                    <Button
                      variant="primary1"
                      onClick={() =>
                        window.open(
                          "/shyftpass#shyft-pass-register-section",
                          "_blank"
                        )
                      }
                    >
                      Buy a shyft past for ₹ 999
                      {arrowRight}
                    </Button>
                  )}
                </div>
              </MobileContainer>
            )}
          </div>
        </div>
      </div>
    </ModalMotion>
  );
};

export default SessionDetailModal;
